export const DAY_TO_MILISECONDS = 1000 * 60 * 60 * 24;
export const HOUR_TO_MILISECONDS = 1000 * 60 * 60;
export const MINUTE_TO_MILISECONDS = 1000 * 60;
export const SECOND_TO_MILISECONDS = 1000;
